import { TealiumUniversalTagOptions } from '@nib-group/tealium-universal-tag/lib/TealiumUniversalTag';

export const tealiumConfig = {
  account: process.env.GATSBY_TEALIUM_ACCOUNT || 'nib',
  profile: process.env.GATSBY_TEALIUM_PROFILE || 'nz',
  environment: process.env.GATSBY_TEALIUM_ENVIRONMENT || 'qa',
  manualPageView: true,
} as TealiumUniversalTagOptions;
